// Badge colorato per categoria/ruolo dei contatti (rubrica, destinatari suggeriti).
// Colori di sfondo saturi + testo esplicito (bianco o #1a1a1a) così il contrasto è
// garantito sia in tema chiaro che scuro: il badge porta sempre i propri colori.
// La categoria professionale è verificata PRIMA del suffisso generico
// (es. "Perito controparte" → verde; "Compagnia controparte" → indigo).
export const ROLE_BADGES = [
  { kw: ["perito"], cls: "bg-emerald-600 text-white" },
  { kw: ["liquidat"], cls: "bg-blue-600 text-white" },
  { kw: ["avvoca", "legale"], cls: "bg-orange-500 text-[#1a1a1a]" },
  { kw: ["medico"], cls: "bg-fuchsia-600 text-white" },
  { kw: ["compagnia"], cls: "bg-indigo-600 text-white" },
  { kw: ["accertat"], cls: "bg-amber-500 text-[#1a1a1a]" },
  { kw: ["carrozz", "riparat"], cls: "bg-cyan-600 text-white" },
  { kw: ["segnalat"], cls: "bg-lime-500 text-[#1a1a1a]" },
  { kw: ["mandant"], cls: "bg-violet-600 text-white" },
  { kw: ["cessionar"], cls: "bg-pink-600 text-white" },
  { kw: ["istruttor"], cls: "bg-sky-600 text-white" },
  { kw: ["commercialist"], cls: "bg-green-700 text-white" },
  { kw: ["agenzia"], cls: "bg-yellow-500 text-[#1a1a1a]" },
  { kw: ["mediazione", "mediaconciliazione"], cls: "bg-purple-600 text-white" },
  { kw: ["cliente"], cls: "bg-teal-600 text-white" },
  { kw: ["controparte"], cls: "bg-rose-600 text-white" },
];

export const roleClass = (role) => {
  const r = (role || "").toLowerCase();
  const m = ROLE_BADGES.find((b) => b.kw.some((k) => r.includes(k)));
  return m ? m.cls : "bg-slate-600 text-white";
};
